<template>
  <v-hover>
    <template v-slot="{ hover }">
      <v-card :elevation="hover ? 6 : 4">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            <v-icon color="white">mdi-apache-kafka</v-icon> Articolo Alternativo
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-2"
                @click="aggiungiArtAlt"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Aggiungi un Articolo Alt.</span>
          </v-tooltip>

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="setArticoloAlt" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-toolbar color="indigo" dense>
              <v-toolbar-title class="white--text">
                <v-icon color="white">mdi-dolly</v-icon> -
                {{ articolo_sel.cod_articolo }}
              </v-toolbar-title>
            </v-toolbar>
            <v-data-table :headers="headers_art_alt" :items="items_art_alt">
              <template v-slot:[`item.quantita`]="{ item }">
                <v-text-field
                  single-line
                  style="display: inline-block; margin-left: 5px; width: 50px"
                  type="number"
                  v-model="item.quantita"
                />
              </template>
              <template v-slot:[`item.elimina`]="{ item }">
                <v-btn @click="eliminaArtAlt(item)" small>
                  <v-icon color="error"> mdi-delete </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>

        <!-- DIALOG cerca articolo -->
        <v-dialog v-model="dialog_agg_art" color="indigo" dense width="60%">
          <v-card>
            <v-toolbar color="indigo" dense>
              <v-toolbar-title class="white--text">
                Aggiungi Articolo
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="dialog_agg_art = false"
                    v-bind="attrs"
                    v-on="on"
                    small
                  >
                    <v-icon color="error"> mdi-close </v-icon>
                  </v-btn>
                </template>
                <span>Chiudi</span>
              </v-tooltip>
            </v-toolbar>

            <v-container>
              <v-row justify="center" align="center" class="mt-1 mb-2">
                <v-col cols="5">
                  <v-text-field
                    hide-details
                    dense
                    v-model="cod_articolo_sel"
                    label="Cerca per cod. articolo"
                  />
                </v-col>
                <v-col cols="2">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="getArticoli"
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="primary"> mdi-magnify </v-icon>
                      </v-btn>
                    </template>
                    <span>Salva</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-data-table
                :headers="headers_lista_art"
                :items="lista_articoli"
              >
                <template v-slot:[`item.seleziona`]="{ item }">
                  <v-btn @click="selezionaArtAlt(item)" small>
                    <v-icon color="primary"> mdi-dolly </v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-container>
          </v-card>
        </v-dialog>

        <!-- Snackbar -->
        <SnackbarQV ref="SnackbarQV" />

        <!-- Overlay -->
        <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </template>
  </v-hover>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class ArticoloAlt {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte i campi
  reset() {
    const campi = this.setControlli();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setControlli() {
    const campi = [
      { nome: "id_articolo_alternativo", default_val: -1 },
      { nome: "id_articolo", default_val: -1 },
      { nome: "id_alternativo", default_val: -1 },
      { nome: "quantita", default_val: "" },
      { nome: "validita", default_val: 1 },
    ];
    return campi;
  }
}

export default {
  name: "ArticoloAlternativo",
  components: {
    SnackbarQV,
  },
  props: {
    articolo_prop: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      articolo_sel: null,
      articolo_alt_sel: new ArticoloAlt(),
      cod_articolo_sel: null,

      // Modal
      dialog_agg_art: false,
      overlay: false,

      // Array
      headers_art_alt: [
        { text: "Cod. Articolo Alt.", value: "cod_articolo" },
        { text: "Des. Articolo Alt.", value: "des_articolo" },
        { text: "Quantità", value: "quantita" },
        { text: "Elimina", value: "elimina" },
      ],
      headers_lista_art: [
        { text: "Seleziona", value: "seleziona" },
        { text: "Cod. Articolo", value: "cod_articolo" },
        { text: "Des. Articolo ", value: "des_articolo" },
      ],
      items_art_alt: [],
      lista_articoli: [],
    };
  },
  computed: {},
  watch: {
    articolo_prop: {
      immediate: true,
      handler() {
        this.articolo_sel = this.articolo_prop;
      },
    },
  },
  methods: {
    aggiungiArtAlt() {
      this.dialog_agg_art = true;
      this.lista_articoli = new Array();
    },
    eliminaArtAlt(item) {
      item.validita = 0;
      this.setArticoloAlt();
    },
    getArticoli() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.getItem("user_token"),
          cod_articolo: this.cod_articolo_sel,
        },
      };
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status == 200) {
            this.lista_articoli = res.data.lista;
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    getArticoloAlt() {
      this.overlay = true;
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoloalternativo",
          token: localStorage.getItem("user_token"),
          filter: " AND ISNULL(articolo_residuo) OR articolo_residuo = 0 ",
          id_articolo: this.articolo_sel.id_articolo,
        },
      };
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.items_art_alt = res.data.result;
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    selezionaArtAlt(item) {
      let check_id_articolo = true;
      let check_id_articolo_principale = true;

      /* Controllo che l'articolo da aggiungere
       * non corrisponda a quello principale. */
      if (item.id_articolo == this.articolo_sel.id_articolo) {
        check_id_articolo_principale = false;
      }

      if (check_id_articolo_principale == false) {
        this.$refs.SnackbarQV.print(
          "orange",
          "L'articolo principale non può essere residuo di sé stesso."
        );
        return;
      }

      /* Controllo che l'articolo da
       * aggiungere non sia già presente. */
      this.items_art_alt.forEach((elem) => {
        if (elem.id_alternativo == item.id_articolo) {
          check_id_articolo = false;
        }
      });

      if (check_id_articolo == false) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Articolo già presente nella lista."
        );
        return;
      }

      let art_tmp;
      art_tmp = new ArticoloAlt();
      art_tmp.id_articolo = this.articolo_sel.id_articolo;
      art_tmp.cod_articolo = item.cod_articolo;
      art_tmp.des_articolo = item.des_articolo;
      art_tmp.id_alternativo = item.id_articolo;
      this.items_art_alt.unshift(art_tmp);
      this.dialog_agg_art = false;
      this.cod_articolo_sel = null;
    },
    setArticoloAlt() {
      this.overlay = true;

      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setarticoloalternativo",
          token: localStorage.getItem("user_token"),
          articolo_alternativo: this.items_art_alt,
        },
      };
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.$refs.SnackbarQV.print(
              "success",
              "Dati salvati correttamente."
            );
            this.getArticoloAlt();
          }
        })
        .catch(() => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
  },
  created() {},
  mounted() {
    this.getArticoloAlt();
  },
};
</script>
<style scoped>
</style>